import { useEffect, useRef } from 'react';

import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import { useReconcileCMChecklist } from '~/hooks/apis/offers/useReconcileCMChecklist';

interface Input {
  evaluation: CmChecklist.Evaluation;
  offerId: string;
}

// Asks the server to clear decisions whose checklist row is gone, once per offer.
// The server skips while a source is failing, so a later visit retries.
export function useReconcileStaleDecisions({ evaluation, offerId }: Input) {
  const { mutate: reconcile } = useReconcileCMChecklist(offerId);
  const reconciledOfferIdRef = useRef<string | undefined>(undefined);
  const hasStaleDecisions = evaluation.manual_overrides_stale.length > 0;

  useEffect(() => {
    if (!hasStaleDecisions || reconciledOfferIdRef.current === offerId) {
      return;
    }

    reconciledOfferIdRef.current = offerId;
    reconcile();
  }, [hasStaleDecisions, offerId, reconcile]);
}
